import React from "react";
import { createRoot } from "react-dom/client";
//import './index.css';
//import 'bootstrap/dist/css/bootstrap.min.css'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import "./assets/styles/bootstrap.custom.css";
import "./assets/styles/index.css";
import "./assets/styles/foodApp.css";

import { SocketContextProvider } from "./SocketContext";

import LoginScreen from "./screens/LoginScreen";
import OrdersScreen from "./screens/OrdersScreen";
import PrivateRoute from "./components/PrivateRoute";
import CreateAdminScreen from "./screens/CreateAdminScreen";
import RegistrationScreen from "./screens/RegistrationScreen";
import CreateOutletScreen from "./screens/CreateOutletScreen";
import CreateFoodItems from "./screens/CreateFoodItems";
import AllFoodItemsScreen from "./screens/AllFoodItemsScreen";
import FoodItemDetailsScreen from "./screens/FoodItemDetailsScreen";
import EditFoodItemDetails from "./screens/EditFoodItemDetails";
import ViewOutletsScreen from "./screens/ViewOutletsScreen";
import OutletDetailsScreen from "./screens/OutletDetailsScreen";
import EditOutletScreen from "./screens/EditOutletScreen";
import OrderDetailsScreen from "./screens/OrderDetailsScreen";
import SalesPage from "./screens/SalesPage";
import GenerateQRCodeScreen from "./screens/GenerateQRCodeScreen";
import OrdersHistoryScreen from "./screens/OrdersHistoryScreen";
import ViewCompanyDetailsScreen from "./screens/ViewCompanyDetailsScreen";
import ViewAdminsScreen from "./screens/ViewAdminsScreen";
import AdminDetailsScreen from "./screens/AdminDetailsScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/register" element={<RegistrationScreen />} />

      {/* <Route path="/" element={<HomePageScreen />} /> */}
      <Route path="" element={<PrivateRoute />}>
        <Route path="/" element={<OrdersScreen />}></Route>
        <Route path="/createFoodItems" element={<CreateFoodItems />} />
        <Route path="/createAdmin" element={<CreateAdminScreen />} />
        <Route path="/createOutlet" element={<CreateOutletScreen />} />
        <Route path="/allFoods" element={<AllFoodItemsScreen />} />
        <Route path="/foodDetails" element={<FoodItemDetailsScreen />} />
        <Route path="/editFoodItem/:id" element={<EditFoodItemDetails />} />
        <Route
          path="/foodItem/:foodItemId"
          element={<FoodItemDetailsScreen />}
        />
        <Route
          path="/editFoodItem/:foodItemId"
          element={<EditFoodItemDetails />}
        />
        <Route path="/viewMyOutlets" element={<ViewOutletsScreen />} />
        <Route
          path="/outletDetails/:outletId"
          element={<OutletDetailsScreen />}
        />
        <Route path="/editOutlet" element={<EditOutletScreen />} />
        <Route path="/orderDetails" element={<OrderDetailsScreen />} />
        <Route path="/orderHistory" element={<OrdersHistoryScreen />} />
        <Route path="/companyDetails" element={<ViewCompanyDetailsScreen />} />
        <Route path="/sales" element={<SalesPage />} />
        <Route path="/generateQR" element={<GenerateQRCodeScreen />} />
        <Route path="/allAdmins" element={<ViewAdminsScreen />} />
        <Route path="/adminDetails" element={<AdminDetailsScreen />} />
      </Route>
    </Route>
  )
);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SocketContextProvider>
        <RouterProvider router={router} />
      </SocketContextProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
